import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class Vendor extends Role implements RoleInterface  {

  public static contactRoleId: number = 5;

  public getName(): string {
    return Translator.trans("role-vendor");
  }

}

export { Vendor }
